// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { Icon } from '../../Icon'

const renderIconText = (props) => {
  const { iconText, popup } = props

  if (!iconText) return null

  const isMoreThan2Chars = iconText.length > 2

  return (
    <span
      style={{
        ...styles.iconText,
        ...(popup && isMoreThan2Chars && styles.smallIconText)
      }}
    >
      {iconText}
    </span>
  )
}

const renderIcon = (props) => {
  const { icon, iconSize, svgIcon, svgIconFill = colors.white, popup } = props

  return svgIcon ? (
    <Icon
      name={svgIcon}
      fill={svgIconFill}
      size={popup ? 13 : iconSize || 20}
    />
  ) : (
    <img
      alt=""
      src={icon}
      style={{ ...styles.icon, ...(popup && styles.popupIcon) }}
    />
  )
}

const renderIconSection = (props) => {
  const {
    borderRadius = 4,
    iconColor = colors.darkblue,
    iconText,
    noIcon,
    popup
  } = props

  if (noIcon) return null

  const iconContainerStyles = {
    background: iconColor,
    borderRadius,
    ...styles.iconContainer,
    ...(popup && styles.popupSection)
  }

  return (
    <div style={iconContainerStyles}>
      {iconText ? renderIconText(props) : renderIcon(props)}
    </div>
  )
}

// Main render function

/**
@description Renders the Image Section for ListItem

@param {number} borderRadius. The icon border radius. Defaults to 4.

@param {string} icon. The icon name. Should be valid for Icon.

@param {string} iconColor. The icon colour string.
s
@param {string} iconText. Text that can be displayed instead of icon.

@param {bool} noIcon. True if no icon to be displayed.

@param {func} renderImage. A renderImage function.

@param {string} svgIcon. String for svgIcon.

@param {string} svgIconFill. Fill for svgIcon.

@returns {function} Image Section
*/

export default function ImageSection(props) {
  const { renderImage } = props

  return (
    <div>{renderImage ? renderImage(props) : renderIconSection(props)}</div>
  )
}

ImageSection.propTypes = {
  borderRadius: PropTypes.number,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconText: PropTypes.string,
  noIcon: PropTypes.bool,
  renderImage: PropTypes.func,
  svgIcon: PropTypes.string,
  svgIconFill: PropTypes.string,
  popup: PropTypes.bool
}

const styles = {
  iconContainer: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    height: 40,
    justifyContent: 'center',
    width: 40
  },
  icon: {
    color: 'white',
    height: 20
  },
  iconText: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold'
  },
  smallIconText: {
    fontSize: 10
  },
  popupSection: { height: 28, width: 28, marginRight: 5 },
  popupIcon: { height: 13 }
}
